import { Helmet } from 'react-helmet-async'

interface MultiLanguageSEOProps {
  displayLanguage?: string | null
}

export const MultiLanguageSEO: React.FC<MultiLanguageSEOProps> = ({
  displayLanguage = 'ja',
}) => {
  // 网站始终使用日语 TDK，不管用户界面语言设置
  const title = '言葉で遊ぼう｜無料の4文字日本語Wordleゲーム'
  const description =
    '言葉で遊ぼう（ことばであそぼう）は、ひらがな4文字の単語を12回以内に当てる無料日本語Wordleゲーム。今日の問題、ヒントモード、過去問カレンダーで語彙と推理を練習できます。'

  return (
    <Helmet>
      <html lang="ja" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:locale" content="ja_JP" />
    </Helmet>
  )
}
